import axios from 'axios'

import { baseURL } from '..'

/**
 * LIST
 * Retorna uma lista de subpublisher de uma rede
 */
export const listSubpublishersKey = 'listSubpublishers'
export const listSubpublishersService = ({
  params
}: ListSubpublishersResquest) =>
  axios.get<ListSubpublisherResponse>(`${baseURL}/subpublishers`, { params })
